// src/services/videoFavoritesAPI.js
import { getAuth } from 'firebase/auth';
import { app } from '../components/firebase';

const API_BASE = 'https://mv-profile-959685280830.asia-south1.run.app/mv-profile/video-courses';

const getValidIdToken = async () => {
  try {
    const auth = getAuth(app);
    const user = auth.currentUser;
    if (!user) throw new Error('No user is logged in. Please login first.');
    return await user.getIdToken(true);
  } catch (error) {
    console.error('Error getting ID token:', error);
    throw new Error(`Authentication failed: ${error.message}`);
  }
};

const getUserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kolkata';

export const videoFavoritesAPI = {

  saveFavorite: async (userId, courseId) => {
    try {
      const idToken = await getValidIdToken();
      const response = await fetch(`${API_BASE}/favorite/${userId}/${courseId}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${idToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ favorite: true }),
      });
      const responseText = await response.text();
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${responseText}`);
      }
      return responseText;
    } catch (error) {
      console.error('Error saving video favorite:', error);
      throw error;
    }
  },

 
  unsaveFavorite: async (userId, courseId) => {
    try {
      const idToken = await getValidIdToken();
      const response = await fetch(`${API_BASE}/favorite/${userId}/${courseId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${idToken}`,
          'Content-Type': 'application/json',
        },
      });
      const responseText = await response.text();
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${responseText}`);
      }
      return responseText;
    } catch (error) {
      console.error('Error removing video favorite:', error);
      throw error;
    }
  },

 
  getFavoriteCourses: async (userId) => {
    try {
      const idToken = await getValidIdToken();
      const zoneId = getUserTimeZone();
      const response = await fetch(
        `${API_BASE}/favorites/${userId}?zoneId=${encodeURIComponent(zoneId)}`,
        {
          method: 'GET',
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );
      if (!response.ok) throw new Error('Failed to fetch video favorite courses');
      const text = await response.text();
      if (!text || text.trim() === '') return [];
      try {
        return JSON.parse(text);
      } catch (e) {
        console.warn('Favorite courses parse error:', text);
        return [];
      }
    } catch (error) {
      console.error('Error fetching video favorites:', error);
      throw error;
    }
  },

  
  getFavoriteCourseDetails: async (userId, courseId) => {
    try {
      const idToken = await getValidIdToken();
      const zoneId = getUserTimeZone();
      const response = await fetch(
        `${API_BASE}/favorites/${userId}/${courseId}?zoneId=${encodeURIComponent(zoneId)}`,
        {
          method: 'GET',
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );
      if (!response.ok) throw new Error('Failed to fetch video favorite course details');
      return await response.json();
    } catch (error) {
      console.error('Error fetching video favorite course details:', error);
      throw error;
    }
  },
};
